import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth/ContextAuthentication';
import { FaUserAlt, FaRegFutbol } from 'react-icons/fa';
import { TbSoccerField } from 'react-icons/tb';
import { ImHome } from 'react-icons/im';
import { BsLockFill } from 'react-icons/bs';
import { MdPassword } from 'react-icons/md';
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { IoCreate } from 'react-icons/io5';
import { BiSolidDiscount } from 'react-icons/bi';
import { MaidanSidebar } from '../utils/svg/MaidanSidebar';

const SideNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const { setAuthenticated, open, setOpen, adminRole } =
    useContext(AuthContext);

  // Set active menu item based on current path
  useEffect(() => {
    const path = location.pathname;
    if (path === '/') setActiveItem('dashboard');
    else if (path === '/playersprofile') setActiveItem('users');
    else if (path === '/matchprofile') setActiveItem('matches');
    else if (path === '/groundprofile') setActiveItem('grounds');
    else if (path === '/sportsbookings') setActiveItem('sportsbookings');
    else if (path === '/academies') setActiveItem('academies');
    else if (path === '/receipts') setActiveItem('receipts');
    else if (path === '/paymentverification')
      setActiveItem('paymentverification');
    else if (path === '/promotions/create' || path === '/promotions/view-all')
      setActiveItem('promotions');
    else if (path === '/updatepassword') setActiveItem('changepassword');
  }, [location.pathname]);

  const handleLogout = () => {
    // Remove the access token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('admin_role');
    // Clear the user authentication
    setAuthenticated(false);
    navigate('/login');
  };

  const handleToggle = () => {
    setOpenMenu((prevOpen) => !prevOpen);
  };

  const handleNavigate = (path, itemName) => {
    setActiveItem(itemName);
    navigate(path);
  };

  // Style for active and inactive menu items
  const getMenuItemStyles = (itemName) => {
    return `flex items-center cursor-pointer p-2 space-x-3 rounded-md ${
      activeItem === itemName ? 'bg-white bg-opacity-20' : ''
    }`;
  };

  const SidebarListBtn = (props) => {
    const { Icon, path, itemName, name } = props;
    return (
      <li className='rounded-sm' onClick={() => handleNavigate(path, itemName)}>
        <div className={getMenuItemStyles(itemName)}>
          <Icon />
          <span className='text-gray-100 text-lg '>{!open ? name : ''}</span>
        </div>
      </li>
    );
  };

  return (
    <div
      className={`${
        open ? 'w-20' : 'w-60'
      } fixed left-0 top-0 h-screen bg-[#0C7240] p-3 duration-300 z-20 overflow-y-auto`}
    >
      <div className='space-y-3 flex justify-center  flex-col'>
        <div className='flex items-center justify-between'>
          <MaidanSidebar />
          <button onClick={() => setOpen(!open)}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='w-6 h-6 text-white'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
              strokeWidth={2}
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M4 6h16M4 12h8m-8 6h16'
              />
            </svg>
          </button>
        </div>
        <div className='flex-1'>
          <ul className='pt-2 pb-4 space-y-1 '>
            <SidebarListBtn
              Icon={() => <ImHome color='white' style={{ fontSize: '24px' }} />}
              path={'/'}
              itemName={'dashboard'}
              name={'Dashboard'}
            />
            <SidebarListBtn
              Icon={() => (
                <FaUserAlt color='White' style={{ fontSize: '24px' }} />
              )}
              path={'/playersprofile'}
              itemName={'users'}
              name={'Users'}
            />
            <SidebarListBtn
              Icon={() => (
                <FaRegFutbol color='White' style={{ fontSize: '24px' }} />
              )}
              path='/matchprofile'
              itemName='matches'
              name='Matches'
            />
            <SidebarListBtn
              Icon={() => (
                <TbSoccerField color='white' style={{ fontSize: '28px' }} />
              )}
              path='/groundprofile'
              itemName='grounds'
              name='Grounds'
            />
            <SidebarListBtn
              Icon={() => (
                <TbSoccerField color='white' style={{ fontSize: '28px' }} />
              )}
              path='/groundsettlement'
              itemName='groundsettlement'
              name='Grounds Settlements'
            />
            <SidebarListBtn
              Icon={() => (
                <AcUnitIcon style={{ fontSize: '24px', color: 'white' }} />
              )}
              path='/sportsbookings'
              itemName='sportsbookings'
              name='Sport Bookings'
            />
            <SidebarListBtn
              Icon={() => (
                <AcUnitIcon style={{ fontSize: '24px', color: 'white' }} />
              )}
              path='/academies'
              itemName='academies'
              name='Academies'
            />
            <SidebarListBtn
              Icon={() => (
                <ReceiptLongIcon style={{ fontSize: '24px', color: 'white' }} />
              )}
              path='/receipts'
              itemName='receipts'
              name='Receipts'
            />
            <SidebarListBtn
              Icon={() => (
                <PaymentIcon style={{ fontSize: '24px', color: 'white' }} />
              )}
              path='/paymentverification'
              itemName='paymentverification'
              name='Payment Verification'
            />

            <li className='rounded-sm'>
              <div
                className={`flex items-center cursor-pointer p-2 space-x-3 rounded-md ${
                  activeItem === 'promotions' ? 'bg-white bg-opacity-20' : ''
                }`}
                onClick={handleToggle}
              >
                {openMenu ? (
                  <IoIosArrowDown
                    style={{ fontSize: '24px', color: 'white' }}
                  />
                ) : (
                  <IoIosArrowForward
                    style={{ fontSize: '24px', color: 'white' }}
                  />
                )}
                <span className='text-gray-100 text-lg'>
                  {!open ? 'Promotions' : ''}
                </span>
              </div>
              {openMenu && (
                <div className={`${!open ? 'ml-6' : ''} mt-2 space-y-2`}>
                  <div
                    className={`cursor-pointer flex items-center p-2 rounded-md space-x-3 ${
                      adminRole === 'Super Admin'
                        ? 'text-gray-100'
                        : 'text-gray-500 cursor-not-allowed'
                    } ${
                      location.pathname === '/promotions/create'
                        ? 'bg-white bg-opacity-20'
                        : ''
                    }`}
                    onClick={() =>
                      adminRole === 'Super Admin' &&
                      handleNavigate('/promotions/create', 'promotions')
                    }
                  >
                    <IoCreate
                      style={{
                        fontSize: '24px',
                        color: adminRole === 'Super Admin' ? 'white' : 'grey',
                      }}
                    />
                    <span className='text-lg'>{!open ? 'Create' : ''}</span>
                  </div>
                  <div
                    className={`cursor-pointer flex items-center p-2 rounded-md text-gray-100 space-x-3 ${
                      adminRole === 'Super Admin'
                        ? 'text-gray-100'
                        : 'text-gray-500 cursor-not-allowed'
                    } ${
                      location.pathname === '/promotions/view-all'
                        ? 'bg-white bg-opacity-20'
                        : ''
                    }`}
                    onClick={() =>
                      adminRole === 'Super Admin' &&
                      handleNavigate('/promotions/view-all', 'promotions')
                    }
                  >
                    <BiSolidDiscount
                      style={{
                        fontSize: '24px',
                        color: adminRole === 'Super Admin' ? 'white' : 'grey',
                      }}
                    />
                    <span className='text-lg '>{!open ? 'View All' : ''}</span>
                  </div>
                </div>
              )}
            </li>
          </ul>
        </div>
        <div>
          <ul className='pt-2 pb-4 space-y-1'>
            <li
              className='rounded-sm'
              onClick={() =>
                handleNavigate('/updatepassword', 'changepassword')
              }
            >
              <div className={getMenuItemStyles('changepassword')}>
                <MdPassword color='white' style={{ fontSize: '24px' }} />
                <span className='text-gray-100 text-lg '>
                  {!open ? 'Change Password' : ''}
                </span>
              </div>
            </li>
            <li className='rounded-sm' onClick={() => handleLogout()}>
              <div className='flex items-center cursor-pointer p-2 space-x-3 rounded-md'>
                <BsLockFill color='White' style={{ fontSize: '24px' }} />
                <span className='text-gray-100 text-lg '>
                  {!open ? 'Logout' : ''}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default SideNav;
